/**
 * Inspeksi Module JS - Layered Architecture & UI Alignment
 */
export function initInspeksi() {
    console.log('[Module] Inspeksi initialized');
    const modalInspeksiElem = document.getElementById('modalInspeksi');
    const modalViewElem = document.getElementById('modalViewInspeksi');
    if (!modalInspeksiElem) return;

    const modalInspeksi = new bootstrap.Modal(modalInspeksiElem);
    const modalView = modalViewElem ? new bootstrap.Modal(modalViewElem) : null;

    const formInspeksi = document.getElementById('formInspeksi');
    const modalTitle = document.getElementById('modalInspeksiLabel');
    const btnAdd = document.getElementById('btnAdd');
    const previewFoto = document.getElementById('previewFoto');

    // --- Create / Edit Logic ---

    if (btnAdd) {
        btnAdd.addEventListener('click', function () {
            // Destroy Select2 instances first to avoid cascading issues during reset
            $(formInspeksi).find('select.select2-hidden-accessible').each(function() {
                $(this).select2('destroy');
            });

            formInspeksi.reset();
            document.getElementById('id_inspeksi').value = "";
            modalTitle.innerHTML = '<i class="bi bi-plus-circle me-2 text-primary"></i>Tambah Inspeksi Baru';

            // Reset all selects silently (no trigger to avoid cascading)
            $(formInspeksi).find('select').each(function() {
                $(this).val(null);
            });

            // Clear readonly display fields
            $('#display_up3, #display_ulp, #display_penyulang, #koordinat').val('');
            $('#id_up3, #id_ulp, #id_penyulang').val('');

            if (previewFoto) {
                previewFoto.classList.add('d-none');
                previewFoto.querySelector('img').src = '';
            }

            // Select2 will be re-initialized via shown.bs.modal event in app.js
            modalInspeksi.show();
        });
    }

    $(document).on('click', '.btnEdit', function () {
        const hash = $(this).data('id');

        Swal.fire({
            title: 'Memuat Data...',
            didOpen: () => { Swal.showLoading(); }
        });

        $.get(`${window.location.origin}/inspeksi/${hash}/json`, function (res) {
            Swal.close();
            if (res.status === 'success') {
                const data = res.data;
                modalTitle.innerHTML = '<i class="bi bi-pencil-square me-2 text-primary"></i>Edit Inspeksi: ' + data.kode_inspeksi;

                document.getElementById('id_inspeksi').value = data.id_inspeksi;
                document.getElementById('tanggal').value = data.tanggal;
                document.getElementById('koordinat').value = data.koordinat;
                document.getElementById('keterangan').value = data.keterangan;

                // Set hidden IDs and display text for readonly fields
                $('#id_up3').val(data.id_up3);
                $('#id_ulp').val(data.id_ulp);
                $('#id_penyulang').val(data.id_penyulang);
                $('#display_up3').val(data.nama_up3 || '');
                $('#display_ulp').val(data.nama_ulp || '');
                $('#display_penyulang').val(data.nama_penyulang || '');
                $('#id_tiang').val(data.id_tiang).trigger('change.select2');

                $('#id_pegawai').val(data.id_pegawai).trigger('change');
                $('#id_komponen').val(data.id_komponen).trigger('change');
                // Wait for cascade to load kondisi options from komponen
                setTimeout(() => {
                    $('#id_kondisi').val(data.id_kondisi).trigger('change');
                }, 800);

                if (data.foto_url && previewFoto) {
                    previewFoto.classList.remove('d-none');
                    previewFoto.querySelector('img').src = data.foto_url;
                } else if (previewFoto) {
                    previewFoto.classList.add('d-none');
                }

                modalInspeksi.show();
            }
        }).fail(() => {
            Swal.fire('Error', 'Gagal memuat data dari server', 'error');
        });
    });

    $(formInspeksi).on('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const formData = new FormData(this);
        const $btn = $(this).find('button[type="submit"]');
        const originalHtml = $btn.html();

        $btn.prop('disabled', true).html('<span class="spinner-border spinner-border-sm me-1"></span> Memproses...');

        $.ajax({
            url: `${window.location.origin}/inspeksi/save`,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function (res) {
                if (res.status === 'success') {
                    modalInspeksi.hide();
                    Swal.fire({
                        icon: 'success',
                        title: 'Berhasil!',
                        text: res.message,
                        timer: 1500,
                        showConfirmButton: false
                    }).then(() => {
                        window.location.reload();
                    });
                }
            },
            error: function (xhr) {
                const res = xhr.responseJSON;
                Swal.fire('Validasi Gagal', res.message || 'Harap periksa kembali inputan Anda', 'error');
            },
            complete: function () {
                $btn.prop('disabled', false).html(originalHtml);
            }
        });
    });

    // --- Auto Fill from Tiang ---
    $(document).on('change', '#id_tiang', function() {
        const hash = $(this).val();
        if(!hash) return;
        
        // Prevent recursive cascading if we are already in the middle of a fetch
        if($(this).data('is-fetching')) return;
        $(this).data('is-fetching', true);

        $.get(`${window.location.origin}/tiang/${hash}/json`, function(res) {
            if(res.status === 'success' && res.data) {
                const data = res.data;
                // Fill hidden IDs
                if(data.id_up3) $('#id_up3').val(data.id_up3);
                if(data.id_ulp) $('#id_ulp').val(data.id_ulp);
                if(data.id_penyulang) $('#id_penyulang').val(data.id_penyulang);
                // Fill display text fields
                $('#display_up3').val(data.nama_up3 || '');
                $('#display_ulp').val(data.nama_ulp || '');
                $('#display_penyulang').val(data.nama_penyulang || '');
                
                if(data.latitude && data.longitude) {
                    $('#koordinat').val(`${data.latitude}, ${data.longitude}`);
                }
            }
        }).always(() => {
            $('#id_tiang').data('is-fetching', false);
        });
    });

    // --- View Detail Logic ---

    $(document).on('click', '.btnView', function () {
        const hash = $(this).data('id');
        if (!modalView) return;

        Swal.fire({
            title: 'Mengambil Detail...',
            didOpen: () => { Swal.showLoading(); }
        });

        $.get(`${window.location.origin}/inspeksi/${hash}/json`, function (res) {
            Swal.close();
            if (res.status === 'success') {
                const data = res.data;
                const $modal = $(modalViewElem);

                // Map data to [data-view-key] elements
                $modal.find('[data-view-key]').each(function () {
                    const key = $(this).data('view-key');
                    $(this).text(data[key] || '-');
                });

                // Handle Foto
                if (data.foto_url) {
                    $('#view_foto').attr('src', data.foto_url).removeClass('d-none');
                    $('#no_foto').addClass('d-none');
                } else {
                    $('#view_foto').addClass('d-none');
                    $('#no_foto').removeClass('d-none');
                }

                // Handle Source Badge
                const sourceBadge = $('#view_source');
                if (data.source === 'mobile') {
                    sourceBadge.html('<i class="bi bi-phone me-1"></i>MOBILE').attr('class', 'badge rounded-pill bg-info-subtle text-info border border-info-subtle px-3 mt-1');
                } else {
                    sourceBadge.html('<i class="bi bi-display me-1"></i>WEB').attr('class', 'badge rounded-pill bg-secondary-subtle text-secondary border border-secondary-subtle px-3 mt-1');
                }

                modalView.show();
            }
        });
    });

    // NOTE: Delete logic is handled by global-crud.js via .btn-delete-submit


    // --- Bulk Action Logic ---

    const btnBulkDelete = document.getElementById('btnBulkDelete');
    const checkAll = document.getElementById('checkAll');
    const selectedCount = document.getElementById('selectedCount');

    function updateBulkUI() {
        const checked = document.querySelectorAll('.row-select:checked');
        if (checked.length > 0) {
            btnBulkDelete.classList.remove('d-none');
            selectedCount.innerText = checked.length;
        } else {
            btnBulkDelete.classList.add('d-none');
        }
    }

    if (checkAll) {
        checkAll.addEventListener('change', function () {
            document.querySelectorAll('.row-select').forEach(cb => cb.checked = this.checked);
            updateBulkUI();
        });
    }

    $(document).on('change', '.row-select', updateBulkUI);

    if (btnBulkDelete) {
        btnBulkDelete.addEventListener('click', function () {
            const ids = Array.from(document.querySelectorAll('.row-select:checked')).map(cb => cb.value);

            Swal.fire({
                title: 'Hapus Massal?',
                text: `${ids.length} data inspeksi terpilih akan dihapus!`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                confirmButtonText: 'Ya, Hapus Semua!'
            }).then((result) => {
                if (result.isConfirmed) {
                    $.post(`${window.location.origin}/inspeksi/bulk-delete`, { ids: ids }, function (res) {
                        if (res.status === 'success') {
                            Swal.fire('Berhasil', res.message, 'success').then(() => {
                                window.location.reload();
                            });
                        }
                    });
                }
            });
        });
    }
    // --- Filter Logic ---
    const filterForm = document.getElementById('filterForm');
    if (filterForm) {
        filterForm.addEventListener('submit', function (e) {
            e.preventDefault();
            const $table = $('.datatable');
            if ($.fn.DataTable.isDataTable($table)) {
                const dt = $table.DataTable();
                const baseUrl = $table.data('ajax-url');
                const params = $(this).serialize();
                dt.ajax.url(`${baseUrl}?${params}`).load();
            }
        });
    }
}

